
export default {
  data() {
    return {
      showToast: false,
      text: "",
      icon: "",
      bgColor: "",
      flat: false,
      showClose: true
    };
  },
  mounted() {},
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "toast/SHOW_MESSAGE") {
        this.text = state.toast.text;
        this.bgColor = state.toast.bgColor;
        this.icon = state.toast.icon;
        this.flat = state.toast.flat;
        this.showToast = true;
      }
    });
    this.$nuxt.$on("show-toast", this.triggerToast);
    this.$nuxt.$on("show-error-toast", this.triggerErrorToast);
  },
  methods: {
    triggerToast(toastObj) {
      if (toastObj) {
        this.showToast = true;
        this.text = toastObj.text;
        this.icon = toastObj.icon;
        this.bgColor = toastObj.color;
        this.flat = toastObj.flat;
        this.showClose = toastObj.showClose == undefined ? true : false;
      }
    },
    triggerErrorToast(data) {
      let msg = "";
      if (
        data &&
        data.response &&
        data.response.data &&
        data.response.data.message
      ) {
        msg = data.response.data.message;
      } else if (data && data.response && data.response.message) {
        msg = data.response.message;
      } else if (data && data.message) {
        msg = data.message;
      } else if (data && data.data && data.data.message) {
        msg = data.data.message;
      } else if (typeof "data" == "string") {
        msg = data;
      } else {
        msg = "Something went wrong!";
      }
      this.triggerToast({
        text: msg,
        color: "error darken-2",
        icon: "error",
        flat: true
      });
    }
  },
  beforeDestroy() {
    this.$nuxt.$off("show-toast");
    this.$nuxt.$off("show-error-toast");
  }
};
